package com.fireavert.units.add_new_unit_client.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class CreateUnitResponse(
    val id: Int? = null
)